module.exports = __webpack_public_path__ + "img/niews-2.5407ec7f.jpeg";